<!--suppress JSUnresolvedVariable -->
<template>
  <div>
    <div class="my-4 mx-1">
      <el-row>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
            >管理中心</el-breadcrumb-item
          >
          <el-breadcrumb-item>用户管理</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="text-primary">角色列表</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </el-row>
      <el-card class="my-4 mx-1 px-3">
        <div slot="header">
          <el-button
            type="primary"
            plain
            size="small"
            @click="addRole()"
            v-if="adminPermissions.includes('/adminRole/admin/addRole')"
          >
            新增角色
          </el-button>

          <el-popconfirm
            placement="right"
            icon="el-icon-info"
            iconColor="red"
            title="确定删除选中的用户吗？"
            @onConfirm="deleteRoles()"
          >
            <el-button
              slot="reference"
              class="ml-3"
              v-if="adminPermissions.includes('/adminRole/admin/deleteRole')"
              plain
              type="danger"
              size="small"
            >
              批量删除
            </el-button>
          </el-popconfirm>
        </div>
        <el-table
          ref="multipleTable"
          :data="roles"
          tooltip-effect="dark"
          stripe
          style="width: 100%;min-height: 450px"
          v-loading="loading"
          element-loading-text="拼命加载中"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column prop="roleId" label="角色ID" sortable width="88">
          </el-table-column>
          <el-table-column prop="nameZh" label="中文名称" align="center">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>
                  <span class="el-popover-span">中文名称：</span
                  >{{ scope.row.nameZh }}
                </p>
                <p>
                  <span class="el-popover-span">英文名称：</span
                  >{{ scope.row.name }}
                </p>
                <p>
                  <span class="el-popover-span">角色描述：</span
                  >{{ scope.row.roleDesc }}
                </p>
                <p>
                  <span class="el-popover-span">创建时间：</span
                  >{{ scope.row.createTime }}
                </p>
                <p>
                  <span class="el-popover-span">修改时间：</span
                  >{{ scope.row.updateTime }}
                </p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium">{{ scope.row.nameZh }}</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="英文名称"> </el-table-column>
          <el-table-column prop="roleDesc" label="角色描述"> </el-table-column>
          <!--<el-table-column prop="createTime" label="创建时间">-->
          <!--</el-table-column>-->
          <!--<el-table-column prop="updateTime" label="修改时间">-->
          <!--</el-table-column>-->
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="145"
          >
            <template slot-scope="scope">
              <el-button
                @click="editRole(scope.row.roleId)"
                v-if="adminPermissions.includes('/adminRole/admin/EditRole')"
                type="primary"
                plain
                size="small"
              >
                编辑
              </el-button>
              <el-button
                type="danger"
                plain
                size="small"
                slot="reference"
                @click="deleteRole(scope.row.roleId)"
                :disabled="scope.row.roleId === 1"
                v-if="adminPermissions.includes('/adminRole/admin/deleteRole')"
              >
                删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "Role",
  data() {
    return {
      multipleSelection: [],
      roleIds: [],
      roles: [],
      adminPermissions: this.$store.state.adminPermissions,
      loading: false
    };
  },
  mounted() {
    this.getRoleList();
  },
  methods: {
    getRoleList() {
      this.loading = true;
      this.axios.get("/adminRole/admin/getRoleList").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.roles = resp.data.data;
          this.loading = false;
        }
      });
    },
    editRole(roleId) {
      this.$router
        .push({ name: "EditRole", params: { roleId: roleId } })
        .catch();
    },
    addRole() {
      this.$router.push({ name: "AddRole" }).catch();
    },
    deleteRole(roleId) {
      if (roleId === 1) {
        this.$alert("不能删除系统管理员！");
        return;
      }
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .delete("/adminRole/admin/deleteRole", {
              params: {
                roleId: roleId
              }
            })
            .then(resp => {
              if (resp && resp.data.code === 10000 && resp.data.success) {
                this.getRoleList();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteRoles() {
      this.multipleSelection.forEach(role => {
        this.roleIds.push(role.roleId);
      });
      if (this.roleIds.includes(1)) {
        this.roleIds = [];
        this.$alert("不能删除系统管理员角色！");
        return;
      }
      this.axios
        .post("/adminRole/admin/deleteRoleList/" + this.roleIds)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.getRoleList();
            this.roleIds = [];
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          }
        });
    }
  }
};
</script>

<style scoped>
.el-popover-span {
  color: #99a9bf;
}
</style>
